import { Trans } from 'react-i18next';
import { toast } from 'react-toastify';

import SVGRenderer from 'root/components/Icon/SVGRenderer';

// icon is using fontawesome, please refer to this link if want to change
// https://react-icons.github.io/react-icons/icons?name=fa
const notification = {
    showNotification(type, content, specialToastParam = null, isSetInnerHtml = false) {
        let toastContent = notification.renderToast(type, content, isSetInnerHtml);

        // special toast configuration
        // please refer https://fkhadra.github.io/react-toastify/api/toast
        // for which item to config
        if (specialToastParam) {
            toast(toastContent, specialToastParam);
        } else {
            toast(toastContent);
        }
    },

    getCorrectIcon(type) {
        switch (type) {
            case 'success':
                return <SVGRenderer category={'SVGReactIcons'} width='1em' height='1em' name='FaCheckCircle' className='success' />;
            case 'error':
                return <SVGRenderer category={'SVGReactIcons'} width='1em' height='1em' name='FaRegTimesCircle' className='error' />;
            case 'warning':
                return <SVGRenderer category={'SVGReactIcons'} width='1em' height='1em' name='FaExclamation' className='warning' />;
            case 'info':
            default:
                return <SVGRenderer category={'SVGReactIcons'} width='1em' height='1em' name='FaInfoCircle' className='info' />;
        }
    },

    getCorrectBootstrapClass(type) {
        switch (type) {
            case 'success':
                return 'text-success';
            case 'error':
                return 'text-danger';
            case 'warning':
            case 'info':
            default:
                return 'text-secondary';
        }
    },

    renderToast(type, content, isSetInnerHtml = false) {
        if (window.isDesignerLayout) {
            return (
                <div className={`standard-notification`}>
                    <div className='alert alert-dark mx-auto d-flex'>
                        {notification.getCorrectIcon(type)}
                        <div className={`fsize-18 ml-3 my-auto ${notification.getCorrectBootstrapClass(type)}`}>{content}</div>
                    </div>
                </div>
            );
        } else {
            return (
                <div className={`standard-notification-container`}>
                    <div className='standard-notification-icon'>{notification.getCorrectIcon(type)}</div>
                    {isSetInnerHtml ? (
                        <div className={`standard-notification-content ${type}`} dangerouslySetInnerHTML={{ __html: content }}></div>
                    ) : (
                        <div className={`standard-notification-content ${type}`}>
                            <Trans defaults={content}></Trans>
                        </div>
                    )}
                </div>
            );
        }
    },
};

export default notification;
